export const adaptableLicense =
  'AppName=Pulse|Owner=Lumatrak|StartDate=2024-09-01|EndDate=2025-09-30|Ref=AdaptableLicense|TS=1725529721702|C=3660617244,1778380879,1260976079,3910778174,323278303,2698435837,3671582174';
